import { render } from "./SuspectActions.vue?vue&type=template&id=30d916c3"
import script from "./SuspectActions.vue?vue&type=script&lang=js"
export * from "./SuspectActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__